import React from 'react';
import { Grid } from 'semantic-ui-react';
import Visibility from '../../components/Visibility';
import { Chart } from '../../components/Chart';
import { Description, SubTitle } from '../../components/layouts';
import './style.scss';
import { useMotionValue, useTransform } from 'framer-motion';
import { motion } from "../../Motion-polyfill";
import { getTrack } from '../../helpers';

const track = getTrack({ block: 17 });

export function PerfDesktop() {
  const [active1, setActive1] = React.useState(true);
  const [active2, setActive2] = React.useState(true);
  const progress = useMotionValue(-1);
  const handleUpdate = React.useCallback(
    (e, { calculations }) => {
      const { percentagePassed } = calculations;
      progress.set(percentagePassed);
    },
    [progress]
  );
  const o1 = useTransform(progress, [-0.5, 0.2], [1, 1]);
  const o2 = useTransform(progress, [-0.5, 0.2], [1, 1]);

  React.useEffect(() => {
    const unsub1 = o1.onChange(() => {
      setActive1(o1.get() > 0.4);
    });
    const unsub2 = o2.onChange(() => {
      setActive2(o2.get() > 0.4);
    });
    return () => {
      unsub1();
      unsub2();
    };
  }, [o1, o2]);

  return (
    <Visibility fireOnMount offset={[-1000, 1000]} onUpdate={handleUpdate} className="page-section section-22 inverted" data-track={track}>
      <motion.div style={{ opacity: o1 }} className="section-content left">
        <Grid columns={2}>
          <div className="eight wide computer sixteen wide tablet column title-column">
            <SubTitle>12+3GB运存的快感</SubTitle>
            <Description>
              X60 Pro在12GB运存<sup>4</sup>
              的基础上、利用内存融合技术<sup>5</sup>
              ，可以调用3GB内存空间到运存进行使用，即刻享受15GB的运存快感。同时实现内核级重构，打造自然连贯的流畅动效。
            </Description>
          </div>
          <div className="eight wide computer sixteen wide tablet column image-column">
            <Chart
              active={active1}
              className="chart-1"
              title="重度应用场景下"
              prev={{
                value: 60,
                total: 100,
                valueLabel: '37%',
                title: <span>运存使用效率提升</span>
              }}
              next={{
                value: 100,
                total: 100,
                valueLabel: '58%',
                title: <span>系统后台保活能力提升</span>
              }}
            />
          </div>
        </Grid>
      </motion.div>
      <motion.div style={{ opacity: o2 }} className="section-content left">
        <Grid columns={2}>
          <div className="eight wide computer sixteen wide tablet column title-column">
            <SubTitle>
              超快闪存UFS 3.1
              <br />
              大文件，秒读
            </SubTitle>
            <Description>超高清电影、视频及超大文件都能够快速读取，轻松满足大家的运行和存储需求，提供更加顺畅的运行体验。</Description>
          </div>
          <div className="eight wide computer sixteen wide tablet column image-column">
            <Chart
              active={active2}
              className="chart-2"
              prev={{
                value: 60,
                total: 100,
                valueLabel: '108%',
                title: (
                  <span>
                    顺序读取速度提升<sup>6</sup>
                  </span>
                )
              }}
              next={{
                value: 100,
                total: 100,
                valueLabel: '513%',
                title: (
                  <span>
                    顺序写入速度提升<sup>6</sup>
                  </span>
                )
              }}
            />
          </div>
        </Grid>
      </motion.div>
    </Visibility>
  );
}
